import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { useAuthStore } from '../store/auth';
import { bootstrapAuth } from '../lib/auth-bootstrap';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void bootstrapAuth().then(() => {
      if (!cancelled) {
        setBooted(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!booted) {
    // Boot splash: resolving the fresh Neon JWT can take a round-trip to
    // the auth domain — don't render the app (or fire any requests) until
    // we know whether the session is still alive.
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface text-on-surface">
        <Loader2 className="h-8 w-8 text-primary animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" />;
  return <>{children}</>;
};
